/***
*
*   HOME LAYOUT
*   Main website layout
*
**********/

import { Fragment } from 'react';
import { HomeNav, Footer, useLocation, useTranslation } from 'components/lib';

export function HomeLayout(props) {

  const location = useLocation();
  const { t } = useTranslation();
  const transparent = location?.pathname === '/' ? true : false;

  return (
    <Fragment>
      <main className='home'>

        <HomeNav transparent={transparent} hideNavItems={props.hideNavItems} />
        {<props.children {...props.data} t={t} />}

      </main>
      <Footer />
    </Fragment>
  );
}
